import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app.component';

bootstrapApplication(App, appConfig)
  .catch((err) => {
    // Use console.error at bootstrap level as LoggerService isn't available yet
    console.error('Application bootstrap failed:', err);
  });
